import React from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import { lightTheme, darkTheme } from '../utils/theme'

/**
 * Componente wrapper que aplica el tema según el estado de Redux
 * Detecta automáticamente cambios en el modo y aplica el tema correspondiente
 */
const ThemeWrapper = ({ children }) => {
  const { mode } = useSelector((state) => state.theme)
  const theme = mode === 'dark' ? darkTheme : lightTheme

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  )
}

export default ThemeWrapper
